import React, {useState, useEffect} from 'react';
import {TextField, IntegerField, PasswordField} from '../fields/text-like-field';
import EmailAddresses from './email-addresses';

const Credentials = ({initialModel, onChange}) => {
  const [model, setModel] = useState(initialModel || {});
  useEffect(() => onChange(model), [model]);
  return <>
    <TextField id="smtpConfigUsername"
               label="Username"
               value={model.username}
               onChange={v => setModel({...model, username: v})}/>
    <PasswordField id="smtpConfigPassword"
                   label="Password"
                   value={model.password}
                   onChange={v => setModel({...model, password: v})}/>
  </>
};

const Support = ({initialModel, onChange}) => {
  const [model, setModel] = useState(initialModel || {});
  useEffect(() => onChange(model), [model]);
  return <>
    <label>Support email addresses</label>
    <div className="form-text mb-2">An alert will be sent to these email addresses if a problem happens (e.g. if our servers cannot connect using this configuration)</div>
    <div className="row justify-content-center">
      <div className="col-12 col-md-10">
        <EmailAddresses initialModel={model.emailAddresses}
                        onChange={v => setModel({...model, emailAddresses: v})}/>
      </div>
    </div>
  </>
};

const SmtpConfig = ({className, initialModel, onChange}) => {

  const [model, setModel] = useState(initialModel || {});

  useEffect(() => onChange(model), [model]);

  return <div className={className}>
    <TextField id="smtpConfigName"
               label="Name"
               helpBlock={<>Helps you identify this SMTP configuration</>}
               value={model.name}
               onChange={v => setModel({...model, name: v})}/>
    <TextField id="smtpConfigHost"
               label="Host / server"
               helpBlock={<>The hostname/server of your email provider, it should be something like <i>smtp.myprovider.com</i></>}
               value={model.host}
               onChange={v => setModel({...model, host: v})}/>
    <IntegerField id="smtpConfigPort"
                  label="Port"
                  helpBlock={<>The port to use, typically 465 or 587</>}
                  value={model.port}
                  onChange={v => setModel({...model, port: v})}/>
    <Credentials initialModel={model.credentials}
                 onChange={v => setModel({...model, credentials: v})}/>
    <TextField id="smtpConfigSenderEmail"
               label="Sender email address"
               helpBlock={<>The email address that appears in the &apos;From&apos; field when an email is sent</>}
               value={model.senderEmailAddress}
               onChange={v => setModel({...model, senderEmailAddress: v})}/>
    <Support initialModel={model.support}
             onChange={v => setModel({...model, support: v})}/>
  </div>;
};

export default SmtpConfig;
